import services from '@/services'

export default {
  getAutomation({ commit }, params) {
    return new Promise((resolve, reject) => {
      services
        .getAutomation(params.organizationId, params.workflowId)
        .then((res) => {
          commit('SETUP_WORKFLOW', res.data.data)
          resolve(res.data.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  updateWorkflow({ commit, state }, params) {
    let name = state.mainWorkflow.name
    let workflowJson = state.mainWorkflow.workflowJson

    let obj = {
      name,
      workflowJson: JSON.stringify(workflowJson),
      lastUpdateDateTime: new Date()
    }

    return new Promise((resolve, reject) => {
      services
        .patchAutomation(params.organizationId, params.workflowId, obj)
        .then((response) => resolve(response.data.data))
        .catch(() => reject())
    })
  },

  finishAutomation({ commit, state }, params) {
    let name = state.mainWorkflow.name
    let workflowJson = state.mainWorkflow.workflowJson

    let obj = {
      name,
      workflowJson: JSON.stringify(workflowJson),
    }

    return new Promise((resolve, reject) => {
      services
        .finishAutomation(params.organizationId, params.workflowId, obj)
        .then(() => resolve())
        .catch((error) => reject(error))
    })
  },

  setCurrentStep: ({ commit }, infoStep) => {
    commit('UPDATE_CURRENT_STEP', infoStep)
  },

  clearCurrentStep: ({ commit }) => {
    commit('CLEAR_CURRENT_STEP')
  },

  setEmailTemplateStep({ commit }, payload) {
    commit('UPDATE_EMAIL_TEMPLATE_STEP', payload)
  },

  setEmailContent: ({ commit }, content) => {
    commit('UPDATE_EMAIL_CONTENT', content)
  },

  setMainWorkflow: ({ commit }, content) => {
    commit('UPDATE_MAIN_WORKFLOW', content)
  },
}
